import React, {useState} from "react";
import {openExchangeSellDispute} from "../../api/exchangeSell";
import {formatActionError} from "./logic";
import {useAuth} from "../../auth";

export function SellDisputeButton({paymentId, onOpened}: {paymentId: string; onOpened?: () => void}): JSX.Element {
    const {token} = useAuth();
    const [open, setOpen] = useState(false);
    const [reason, setReason] = useState("");
    const [pending, setPending] = useState(false);
    const [error, setError] = useState("");
    const [opened, setOpened] = useState(false);
    const submit = async (): Promise<void> => {
        if (!reason.trim() || pending) return;
        setPending(true); setError("");
        try {
            await openExchangeSellDispute(paymentId, token, reason.trim());
            setOpened(true); setOpen(false); onOpened?.();
        } catch (err) { setError(formatActionError(err)); }
        finally { setPending(false); }
    };
    return <>
        <button type="button" className="btn btn-appeal" disabled={opened || pending} onClick={() => setOpen(true)}>{opened ? "Спор открыт" : "Открыть спор"}</button>
        {opened && <div role="status">Спор передан администратору. Заявка остаётся у вас.</div>}
        {open && <div className="confirm-backdrop">
            <div className="confirm-modal" role="dialog" aria-modal="true" aria-label="Открыть спор">
                <h3>Открыть спор</h3>
                <p>Администратор увидит заявку и причину обращения. Закрыть заявку без поступлений может только администратор.</p>
                <label className="requisites-field"><span>Причина спора</span><textarea autoFocus rows={3} value={reason} maxLength={2000} disabled={pending} onChange={(event) => setReason(event.target.value)}/></label>
                {error && <div className="confirm-error" role="alert">{error}</div>}
                <div className="confirm-actions"><button type="button" className="btn btn-ghost" disabled={pending} onClick={() => setOpen(false)}>Назад</button><button type="button" className="btn btn-appeal" disabled={pending || !reason.trim()} onClick={() => void submit()}>{pending ? "Открываем…" : "Передать администратору"}</button></div>
            </div>
        </div>}
    </>;
}
